import React from 'react'
import { DataGrid, GridCellEditStopReasons,useGridApiEventHandler,useGridApiRef } from '@mui/x-data-grid';
import Button from '@mui/material/Button';

const columns = [
    {
        field: 'dealers',
        headerName: 'Dealers',
        headerClassName:'dealerheader',
        width: 250,
        cellClassName:"dealercolumn"
    },
    {
        field: 'products_1',
        headerName: 'Products 1',
        type: 'text',
        editable: true,
        align: 'left',
        headerAlign: 'left',
        width: 160,
    },
    {
        field: 'products_2',
        headerName: 'Products 2',
        type: 'text',
        editable: true,
        align: 'left',
        headerAlign: 'left',
        width: 160,
    },
    {
        field: 'products_3',
        headerName: 'Products 3',
        type: 'text',
        editable: true,
        align: 'left',
        headerAlign: 'left',
        width: 160,
    },
    {
        field: 'products_4',
        headerName: 'Products 4',
        type: 'text',
        editable: true,
        align: 'left',
        headerAlign: 'left',
        width: 160,
    },
    {
        field: 'products_5',
        headerName: 'Products 5',
        type: 'text',
        editable: true,
        align: 'left',
        headerAlign: 'left',
        width: 160,
    },
    {
        field: 'products_6',
        headerName: 'Products 6',
        type: 'text',
        editable: true,
        align: 'left',
        headerAlign: 'left',
        width: 160,
        renderCell: (params) => (
            <strong>
              
              <Button
                variant="contained"
                size="small"
                style={{ marginLeft: 16 }}
                tabIndex={params.hasFocus ? 0 : -1}
              >
                Open
              </Button>
            </strong>
          ),
    },
];

const rows = [
    {
        id: 1,
        dealers: 'Rena Collins',
        products_1: 'Product One',
        products_2: 'Product One',
        products_3: 'Product One',
        products_4: 'Product One',
        products_5: 'Product One',
        products_6: 'Product One',

    },
    {
        id: 2,
        dealers: 'Rena Collins',
        products_1: 'Product One',
        products_2: 'Product One',
        products_3: 'Product One',
        products_4: 'Product One',
        products_5: 'Product One',
        products_6: 'Product One',

    },
    {
        id: 3,
        dealers: 'Rena Collins',
        products_1: 'Product One',
        products_2: 'Product One',
        products_3: 'Product One',
        products_4: 'Product One',
        products_5: 'Product One',
        products_6: 'Product One',

    },
    {
        id: 4,
        dealers: 'Rena Collins',
        products_1: 'Product One',
        products_2: 'Product One',
        products_3: 'Product One',
        products_4: 'Product One',
        products_5: 'Product One',
        products_6: 'Product One',

    },
    {
        id: 5,
        dealers: 'Rena Collins',
        products_1: 'Product One',
        products_2: 'Product One',
        products_3: 'Product One',
        products_4: 'Product One',
        products_5: 'Product One',
        
        

    },
    
];


function TargetsTable() {
 
    const processRowUpdate = (newRow) => {
        const response = newRow;
        console.log(response)
        return response;
    }

  
   


    return (
        <>
            <div style={{ height: 400, width: '100%', marginTop: '1rem', background: '#ffff' }}>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    // apiRef={apiRef}
                    processRowUpdate={processRowUpdate}
                    // onCellEditStop={(params, event) => {
                    //     console.log(params.reason);
                    //     console.log(event.type)
                    //     if (params.reason === GridCellEditStopReasons.cellEditStop) {
                    //       event.defaultMuiPrevented = false;
                    //     }
                    //   }}
                    // onCellClick={handleEvent}
                />
            </div>
        </>
    )
}

export default TargetsTable